import request from "@/utils/request"


export function getWebsite(){
    return request({
        url:'/website/use',
        method:'get',
    })
}